import { render, staticRenderFns } from "./ms-drugright-drugtwo.vue?vue&type=template&id=07ecd93e&scoped=true"
import script from "./ms-drugright-drugtwo.vue?vue&type=script&lang=js"
export * from "./ms-drugright-drugtwo.vue?vue&type=script&lang=js"
import style0 from "./ms-drugright-drugtwo.vue?vue&type=style&index=0&id=07ecd93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ecd93e",
  null
  
)

export default component.exports